//
// Generated class EventProduct
//

/// <reference path="EventProduct_ManagedObject.ts" />

class EventProduct extends EventProduct_ManagedObject
{

}
